import axiosInstance from "./authentication/axiosInstance";

export const holidayServices = {

  getAllHolidays: async (page = 0, size = 10, search = '', sortField = 'holidayDate', sortDir = 'asc') => {
    const params = new URLSearchParams({
      pageNo: page,
      size,
      sortField,
      sortDir,
    });
    if (search) params.set('search', search);

    const response = await axiosInstance.get(`/holiday/all?${params.toString()}`);
    return response.data;
  },

  addHoliday: async (payload, userId, userName, roles) => {
    const params = new URLSearchParams();
    if (userId) params.set('userId', userId);
    if (userName) params.set('userName', userName);
    if (roles) params.set('roles', Array.isArray(roles) ? roles.join(',') : roles);

    const response = await axiosInstance.post(`/holiday/add?${params.toString()}`, payload);
    return response.data;
  },

  updateHoliday: async (payload, userId, userName, roles) => {
    const params = new URLSearchParams();
    if (userId) params.set('userId', userId);
    if (userName) params.set('userName', userName);
    if (roles) params.set('roles', Array.isArray(roles) ? roles.join(',') : roles);

    const response = await axiosInstance.put(`/holiday/update?${params.toString()}`, payload);
    return response.data;
  },

  deleteHoliday: async (id, userId, roles) => {
    const params = new URLSearchParams();
    if (userId) params.set('userId', userId);
    if (roles) params.set('roles', Array.isArray(roles) ? roles.join(',') : roles);

    const response = await axiosInstance.delete(`/holiday/delete/${id}?${params.toString()}`);
    return response.data;
  },

  getHolidaysBetween: async (startDate, endDate) => {
    const params = new URLSearchParams({ startDate, endDate });
    const response = await axiosInstance.get(`/holiday/between?${params.toString()}`);
    return response.data;
  },

};

